<template>
    <div class="cart-order-options grid-x" v-if="availableOptions.length">
        <div class="order-option cell" v-for="option in availableOptions" :key="option.id">
            <div class="grid-x align-middle">
                <div class="cell shrink">
                    <img v-if="option.image_url" class="order-option-icon" :src="option.image_url" :alt="option.label + ' Icon'">
                </div>
                <div class="cell auto">
                    <checkbox @change="select(option.id, $event)" :label="option.label" :label-left="true" :checked="isSelected(option.id)"></checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import CartModule from '@/stores/modules/cart';
import Settings, { SettingNamespace } from '@/utils/settings';
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import Checkbox from '@/components/common/ui/Checkbox.vue';
import { OrderOption } from '@/utils/types';

@Component({
    components: { Checkbox }
})
export default class CartOrderOptions extends Vue
{
    cartModule!: CartModule;
    availableOptions: OrderOption[] = [];

    async created() {
        this.cartModule = getModule(CartModule, this.$store);
        const settings = await Settings.getInstance();
        this.availableOptions = settings.get(SettingNamespace.ORDERS, 'order_options')?.value || [];
        for (let i = 0; i < this.availableOptions.length; i++) {
            if (this.availableOptions[i].default_value) {
                this.cartModule.addOrderOption(this.availableOptions[i].id);
            }
        }
    }

    select(optionId: string, selected: boolean) {
        if (selected) {
            this.cartModule.addOrderOption(optionId);
        } else {
            this.cartModule.removeOrderOption(optionId);
        }
    }

    get isSelected() {
        return (optionId: string) => {
            return this.cartModule.orderOptions.indexOf(optionId) !== -1;
        };
    }
}
</script>
<style lang="scss" scoped>

.cart-order-options {
    border-top: var(--cart-separator);
    border-color: var(--cart-separator-color);
    padding: 15px 0;
    margin: 15px 0 30px;

    .order-option {
        padding: 15px 0;

        .order-option-icon {
            height: 30px;
            width: 30px;
            margin-right: 10px;
        }
    }
}

</style>
